import styled from 'styled-components';
import device from '@deprecated-ui/_style/device';
import { SCardContainer, SMainContainer, SPaneContainer } from './Main/styled';
import { SHeaderEbook } from './Header/Header';
import { SDownloadButton } from './Main/Pane';

interface IStyledEbookContainer {
  isPaneActive?: boolean;
  isEbookPageViewAsMobile?: boolean;
}
const StyledEbookContainer = styled.div<IStyledEbookContainer>`
  position: relative;
  display: block;
  margin-right: unset;

  @media ${device.tablet} {
    margin-right: 30px;
  }

  ${({ isPaneActive }) =>
    isPaneActive &&
    `display: grid;
      grid-template-columns: 50% 50%;
      grid-gap: 30px;

      ${SCardContainer} {
        width: 120px;
      }`}

  ${({ isEbookPageViewAsMobile, isPaneActive }) =>
    isPaneActive &&
    isEbookPageViewAsMobile &&
    `display: block;
      grid-template-columns: unset;
      grid-gap: unset;

      ${SMainContainer} {
        display: none;
      }

      ${SHeaderEbook} {
        width: 125%;
      }

      ${SPaneContainer} {
        width: 125%;
        border-left: unset;
        border-right: unset;
      }

      ${SDownloadButton} {
        float: unset;
        bottom: unset;
        width: 90%;
        margin-top: 8px;
        margin-bottom: 8px;
      }`}
`;

const StyledEbookWrapper = styled.div`
  position: relative;
  display: block;
  padding-bottom: 15px;
`;

export { StyledEbookContainer, StyledEbookWrapper };
